/**
 * 白名单模块的接口
 * */
import base from './base' // 接口域名列表
import axios from '@/utils/http' // 导入创建的axios实例
import qs from 'qs' // 序列化post请求的
import constant from '../utils/constant'

let www = base.proxy

axios.defaults.headers.common['token'] = constant.getToken()

// 开始定义接口
const whitelist = {
  getIpAddressApi () {
    return axios.post(`${www}/wtapi/external/api/config/ipAddress`)
  },
  setIpAddressApi (params) {
    return axios.post(`${www}/wtapi/external/api/config/save/ipList`, qs.stringify(params))
  }
}

export default whitelist



// WEBPACK FOOTER //
// ./src/api/whitelist.js